import { Zap, Cloud, Scale, Moon, Waves, HeartHandshake } from "lucide-react";
import { useTranslation } from "react-i18next";

const SignalsSection = () => {
  const { t } = useTranslation();
  const signals = [
    { icon: Zap,            symptom: t("signals.s1_symptom"), signal: t("signals.s1_signal") },
    { icon: Cloud,          symptom: t("signals.s2_symptom"), signal: t("signals.s2_signal") },
    { icon: Scale,          symptom: t("signals.s3_symptom"), signal: t("signals.s3_signal") },
    { icon: Moon,           symptom: t("signals.s4_symptom"), signal: t("signals.s4_signal") },
    { icon: Waves,          symptom: t("signals.s5_symptom"), signal: t("signals.s5_signal") },
    { icon: HeartHandshake, symptom: t("signals.s6_symptom"), signal: t("signals.s6_signal") },
  ];

  return (
    <section
      data-testid="signals-section"
      className="section-padding bg-[#F9F8F6]"
    >
      <div className="max-w-6xl mx-auto">
        <div className="max-w-3xl mb-16">
          <span className="overline mb-4 block">{t("signals.overline")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-6xl text-[#2C3524] leading-[1.1] mb-8">
            {t("signals.titlePart1")}<br />
            <span className="text-[#C5A059] italic">{t("signals.titlePart2")}</span>
          </h2>
          <p className="text-[#4A5543] text-lg md:text-xl font-light leading-relaxed">
            {t("signals.intro")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {signals.map((item, index) => (
            <div
              key={index}
              className="group relative p-8 rounded-2xl border border-[#E3DAC9] bg-white hover:border-[#C5A059] transition-all duration-500"
              data-testid={`signal-${index}`}
            >
              <div className="flex items-start justify-between mb-6">
                <item.icon className="w-8 h-8 text-[#C5A059]" strokeWidth={1.5} />
                <span className="text-xs tracking-[0.15em] uppercase text-[#4A5543]/50">
                  {t("signals.signalLabel", { n: index + 1 })}
                </span>
              </div>
              <h3 className="font-heading text-2xl text-[#2C3524] mb-3">
                {item.symptom}
              </h3>
              <p className="text-[#4A5543] font-light text-sm leading-relaxed">
                {item.signal}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 max-w-4xl">
          <p className="font-heading text-2xl md:text-3xl text-[#2C3524] leading-relaxed italic">
            {t("signals.quotePart1")}
            <span className="text-[#C5A059]">{t("signals.quotePart2")}</span>
          </p>
          <p className="mt-4 text-[#4A5543] text-sm tracking-[0.15em] uppercase">
            {t("signals.quoteAuthor")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default SignalsSection;
